import { useEffect, useState } from "react";
import FavoriteCombinations from "./favoriteCombinations";
import FavoriteSku from "./favoriteSku";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsFavoriteSku, setIsProductPage } from "../../../store";

const FavoritePage = ({
    order_details_id,
    analysis_details_id,
    switchTab,
    supportFilter,
    sortBy,
    searchQueryForItemsets,
    selectedCombo,
    setCountItemSet
}) => {
    const [activeTab, setActiveTab] = useState("combinations");
    const dispatch = useDispatch()

    useEffect(()=>{
        setActiveTab("combinations")
        dispatch(setIsProductPage(false))
    },[switchTab])

    return (
        <div className="p-6 bg-white rounded-lg shadow-md">
            {/* Header */}
            {/* <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Favorites</h2>
            </div> */}

            {/* Tabs */}
            <div className="flex gap-4 mb-6 border-b">
                <button
                    onClick={() => {
                        dispatch(setIsFavoriteSku(false))
                        dispatch(setIsProductPage(false))

                        setActiveTab("combinations")}}
                    className={`px-4 py-2 font-medium text-sm border-b-2 ${activeTab === "combinations"
                            ? "text-blue-600 border-blue-600"
                            : "text-gray-500 border-transparent hover:text-blue-600"
                        }`}
                >
                    Favorite Combinations
                </button>
                <button
                    onClick={() => {
                        setActiveTab("sku")
                        dispatch(setIsFavoriteSku(true))
                    }}
                    className={`px-4 py-2 font-medium text-sm border-b-2 ${activeTab === "sku"
                            ? "text-blue-600 border-blue-600"
                            : "text-gray-500 border-transparent hover:text-blue-600"
                        }`}
                >
                    Favorite SKUs
                </button>
            </div>

            {/* Tab Content */}
            {activeTab === "combinations" ? (
                <FavoriteCombinations
                    order_details_id={order_details_id}
                    analysis_details_id={analysis_details_id}
                    switchTab={switchTab}
                    supportFilter={supportFilter}
                    sortBy={sortBy}
                    searchQueryForItemsets={searchQueryForItemsets}
                    selectedCombo={selectedCombo}
                    setCountItemSet={setCountItemSet}
                />
            ) : (
                <FavoriteSku
                    order_details_id={order_details_id}
                    analysis_details_id={analysis_details_id}
                    switchTab={switchTab}
                    supportFilter={supportFilter}
                    searchQueryForItemsets={searchQueryForItemsets}
                    selectedCombo={selectedCombo}
                    setCountItemSet={setCountItemSet}
                />
            )}
        </div>
    );
};

export default FavoritePage;
